import { render, staticRenderFns } from "./SubscriptionsType.vue?vue&type=template&id=9cbe6678&"
import script from "./SubscriptionsType.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports